import axios from 'axios'
import config from '@/config'

const chatbotRoute = `${config.ENDPOINTS.CHATBOT_BACKEND}/api/v1/report`

const USAGE_WORKFLOW_ID = {
  codelco: 2347,
  amsa: 3104
}

async function downloadReport (path) {
  const { data } = await axios.get(
    `${chatbotRoute}/${path}`,
    {
      responseType: 'blob',
      auth: {
        username: config.ENDPOINTS.CHATBOT_AUTH_USERNAME,
        password: config.ENDPOINTS.CHATBOT_AUTH_PASSWORD
      }
    }
  )
  return data
}

const chatbot = {
  namespaced: true,
  actions: {
    async downloadActivityReport (_, client) {
      try {
        return await downloadReport(`${client}/reporte_actividad_${client}`)
      } catch (error) {
        console.error(`Error downloading activity report for ${client}:`, error)
        throw error
      }
    },
    async downloadUsageReport (_, client) {
      try {
        return await downloadReport(`${client}/${USAGE_WORKFLOW_ID[client]}`)
      } catch (error) {
        console.error(`Error downloading usage report for ${client}:`, error)
        throw error
      }
    }
  }
}

export default chatbot



// WEBPACK FOOTER //
// ./src/store/modules/chatbot.js